import { render, staticRenderFns } from "./ModelSettings.vue?vue&type=template&id=2e905fff&"
import script from "./ModelSettings.vue?vue&type=script&lang=js&"
export * from "./ModelSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports